<template>
  <div class="article-header-banner">
    <h1 class="header-title">{{ title }}</h1>
    <p v-if="description" class="header-description" v-html="description"></p>
  </div>
</template>

<script>
export default {
  name: 'header-banner',
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },
};
</script>
